module.exports = __webpack_public_path__ + "static/banner-online-doctor-beea5f528af65e4f5823261d7c4794f8.jpg";